export enum EFiscalDocumentStatus {
  Pending = 0,
  Processing = 1,
  Authorized = 2,
  Rejected = 3,
  Contingency = 4,
  Canceled = 5,
  CancellationPending = 6,
}
